export default __webpack_public_path__ + "static/netcore-d4caf44ff69efb1dbdd3ce6c15ab886b.svg";